import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,[_c('PageWrapper',[_c('PageContent',[_c('div',{staticClass:"menu"},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VImg,{attrs:{"src":require("@/assets/images/mk-logo.png"),"max-width":"500"}})],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }